import {VariantConfigT} from '@/lib/types/colors.types';

export const mutedConfig: VariantConfigT = {
  basic: {
    icon: 'muted',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'muted',
    active: 'muted',
  },
  outline: {
    icon: 'muted',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'muted',
    iconHover: 'muted',
    iconActive: 'muted',
    hover: 'muted',
    active: 'muted',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
